import LargeCardsBlock from './LargeCardsBlock';
import SingleCenteredBlock from './SingleCenteredBlock';
import SingleLargeImageBlock from './SingleLargeImageBlock';
import TilesBlock from './TilesBlock';
import ImagesSwitchingSidesBlock from './ImagesSwitchingSidesBlock';
import TopBlock from './TopBlock';
import SmallCardsBlock from './SmallCardsBlock';
import TopBlockSelector from './TopBlockSelector';
import TabPagesBlock from './TabPagesBlock';
import ArticlesBlock from './ArticlesBlock';
import HelpBlock from './HelpBlock/HelpBlock';
import StepsBlock from './StepsBlock';
import MediumCardsBlock from './MediumCardsBlock';
import PicturesBlock from './PicturesBlock';
import KeyplanSimulationBlock from './SimulationBlocks/KeyplanSimulationBlock';
import KeyprivateSimulationBlock from './SimulationBlocks/KeyprivateSimulationBlock';
import RichTextBlock from './RichTextBlock';
import ContactBlock from './ContactBlock/ContactBlock';
import IconBenefitsBlock from './IconBenefitsBlock';
import VisaComparisonTableBlock from './VisaComparisonTableBlock';
import JobListingBlock from './job/JobListingBlock';
import SeminarListingBlock from './seminar/SeminarListingBlock';
import SeminarTopicSBlock from './seminar/SeminarTopicSBlock';
import ReactComponent from '../ReactComponent';
import MediaList from '../media/MediaList';

export default {
  LargeCardsBlock,
  SingleCenteredBlock,
  SingleLargeImageBlock,
  ImagesSwitchingSidesBlock,
  TopBlock,
  SmallCardsBlock,
  TilesBlock,
  TopBlockSelector,
  TabPagesBlock,
  ArticlesBlock,
  HelpBlock,
  StepsBlock,
  MediumCardsBlock,
  PicturesBlock,
  KeyplanSimulationBlock,
  KeyprivateSimulationBlock,
  RichTextBlock,
  ContactBlock,
  IconBenefitsBlock,
  VisaComparisonTableBlock,
  JobListingBlock,
  SeminarListingBlock,
  SeminarTopicSBlock,
  ReactComponent,
  MediaList,
};
